// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3biEv","colMin":"styles_colMin__2OB9d"};